import React from 'react';
import moment from "moment";
import {Link} from "react-router-dom";
function TaskItem({item,link,delete_archive}) {
    const { name, company_name, accountant_first_name, accountant_last_name, end_task_date, end_date } = item;
    return (
        <div className="user-task-cont">
            <Link to={link} className='user-task'>
                <span>{name}</span>
                <span>{company_name}</span>
                <span>{accountant_first_name} {accountant_last_name}</span>
                <span>{end_task_date ? moment(end_task_date).format('LLL') : ''}</span>
                <span>{end_date ? moment(item.end_date).format('LLL') : ''}</span>
            </Link>
            <div className="tool-tip-cont">
                <div className="tool-tip">Ջնջել</div>
                <i className="fas fa-times" onClick={delete_archive}/>
            </div>
        </div>
    );
}

export default TaskItem;